<div>
  <form id='npform'>
    <input [(ngModel)]="email" type="text" class="newProjectItem" name="email"
      placeholder="email" id='email'>
    <textarea value={{message}} [(ngModel)]="message" class="newProjectItem" name="info"
      placeholder="message" id='message'></textarea>
    <a (click)="saveData()" routerLink="/"><button id='submit' type="submit">Contact Me</button></a>
  </form>
</div>
